module.exports = __webpack_public_path__ + "static/typography-mockup-bd392a5d9c539c4cf8b5b129aef21067.png";